import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Featuresimpact() {
  return (
    <section className="features_impact p-100 bg_blue">
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>Features Of The S.E.L.F Web App</h2>
            <p>
              Successfully enabling an institute to monitor the E.Q level of
              their students, the web app was able to foster a culture of
              developing high E.Q in students. The following features of the
              S.E.L.F app made it seamless for the staff of an organization to
              extract data:
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="feature_box">
              <div className="num">01</div>
              <p>
                Guided journals for teachers and students using grade plans.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="feature_box">
              <div className="num">02</div>
              <p>Hosts events for students and teachers via zoom.</p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="feature_box">
              <div className="num">03</div>
              <p>Conduct surveys across grades</p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="feature_box">
              <div className="num">04</div>
              <p>Monitor daily temperature checks for students and teachers.</p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="feature_box">
              <div className="num">05</div>
              <p>Extensive reporting for school admins and teachers.</p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="feature_box">
              <div className="num">06</div>
              <p>
                Monitor moods of students conveniently through the dashboard of
                the app.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Featuresimpact;
